import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { Carts } from '../../../core/services/carts.service';
import { Auth } from '../../../core/services/auth.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './header.html',
  styleUrl: './header.css',
})
export class Header implements OnInit {

  @Output() openLoginModal = new EventEmitter<void>();

  isDarkText = false;
  isLoggedIn = false;
  userInitial = '';
  showUserMenu = false;
  isAdmin: boolean = false;

  constructor(
    private router: Router,
    public cart: Carts,
    public auth: Auth,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.updateHeaderStyle(this.router.url);
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.updateHeaderStyle(event.urlAfterRedirects || event.url);
    });

    this.checkLoginStatus();
    this.auth.sessionExpired$.subscribe(() => {
      this.showUserMenu = false;
      this.checkLoginStatus();
    });
  }

  private updateHeaderStyle(url: string) {
    this.isDarkText = url.includes('/shop') || url.includes('/product') ||
      url.includes('/checkout') || url.includes('/profile') || url.includes('/club');
  }

  handleLoginClick() { this.openLoginModal.emit(); }

  checkLoginStatus() {
    this.isLoggedIn = this.auth.isLoggedIn();
    if (this.isLoggedIn) {
      const username = this.auth.getUsernameFromToken(this.auth.getToken() || '');
      this.userInitial = username.charAt(0).toUpperCase();
      this.isAdmin = this.auth.isAdmin();
    } else {
      this.isAdmin = false;
      this.userInitial = '';
    }
  }

  handleUserClick() {
    if (this.isLoggedIn) {
      this.showUserMenu = !this.showUserMenu;
    } else {
      this.openLoginModal.emit();
    }
  }

  logout() {
    this.showUserMenu = false;

    this.messageService.add({
      severity: 'success',
      summary: 'Cerrando sesión',
      detail: 'Hasta pronto'
    });

    setTimeout(() => {
      this.auth.logout().subscribe(() => {
        this.isLoggedIn = false;
        this.isAdmin = false;
        this.userInitial = '';
        this.router.navigate(['/']);
        window.location.reload();
      });
    }, 1500);
  }
}
